import { render, staticRenderFns } from "./ProductBusClsReview.vue?vue&type=template&id=2c4dead8&"
import script from "./ProductBusClsReview.vue?vue&type=script&lang=js&"
export * from "./ProductBusClsReview.vue?vue&type=script&lang=js&"
import style0 from "./ProductBusClsReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductBusClsReview.vue"
export default component.exports